import React from 'react';

const PlayerTeamsItem = ({ size, team }) => (
  <div className="cateogry">
    <img src={team.badge.url} alt={team.name} style={{ height: `${1.6 * size}rem` }} />
  </div>
);

export default PlayerTeamsItem;
